export default "__VITE_ASSET__Bor8ATyL__"